import { Component, Input, OnInit, HostBinding } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: "ig-card",
    templateUrl: "./card.component.html",
    styleUrls: ["./card.component.scss"],
})
export class CardComponent implements OnInit {
    @Input()
    public id: number;

    @Input()
    public imageUrl: string;

    @Input()
    public title: string;

    @Input()
    public selected: boolean;

    @Input()
    public compact: boolean;

    @HostBinding("class.card--compact")
    public get classNameCompact(): boolean {
        return this.compact === true;
    }

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
    }

    public get unescapedHtml() {
        return this.sanitizer.bypassSecurityTrustHtml(this.title);
    }

}
